import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Catalog } from "../components/Catalog";
import { Services } from "../components/Services";
import { Manifesto } from "../components/Manifesto";
import { Founder } from "../components/Founder";
import { ContactForm } from "../components/ContactForm";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Catalog />
      <Services />
      <Manifesto />
      <Founder />
      <Marquee dark />
      <ContactForm />
    </main>
  );
}
